<template>
  <div class="gs-app gm-campaigns-refresh">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>

    <div class="flex mb-4 mx-2">
      <div class="w-full gm-campaigns-refresh__workspace">
        <!-- Can mail/Upgraded user/Sandbox mode check -->
        <div
          class="w-full btn-radius bg-white text-grey-700 p-4 mb-2"
          style="box-shadow: 10px 5px 10px 0 rgba(22, 29, 37, 0.05)"
          v-if="showSenderBanner && this.userCanMail"
          :style="{ display: hideBanner ? 'none' : 'block' }"
        >
          <create-sender-banner
            @closeSenderBanner="closeSenderBanner"
            @smsSenderCreated="closeSenderBanner"
          />
        </div>
        <!-- Can mail/Upgraded user/Sandbox mode check -->

        <navigation-tabs
          v-if="showNavTabs"
          class="gm-nav-campaigns-tabs my-5 lg:my-0 lg:absolute"
          :class="{ 'gm-nav-campaigns-tabs-no-sender': showSenderBanner && this.userCanMail && !hideBanner}"
          :nav_tabs="navTabs"
        />
        <server-table
          class="w-full text-center groovemail-campaigns-table gs-refresh-controls"
          url="/campaign"
          ref="serverTable"
          tableRef="campaignsTable"
          :slotData="campaignSlotData"
          :tableColumns="mail_listsTableColumns"
          :tableOptions="mail_listsTableOptions"
          :emptyStateData="emptyStateData"
          tableTitle="frontend_groovemail_broadcasts_route_page_title"
          addNewBtnText="frontend_groovemail_campains_index_new_campaigns"
          @addNewData="openCreateCampaign"
          @loaded="hideLoader()"
          @loading="showLoader()"
          @sorted="sortedTable"
        >
          <template slot="top-right-content">
            <gd-dropdown
              class="text-left"
              size="full"
              v-model="percentSwitch"
              :options="dropdownOptions"
              @change="changeDataView"
            />
          </template>
        </server-table>
      </div>
    </div>

    <gs-named-modal class="gs-refresh-controls"
      id="subscribermodel"
      name="view-opens-modal"
      :title="$t('frontend_groovemail_broadcasts_unique_opens')"
    >
      <VuePerfectScrollbar>
        <server-table
          class="w-full text-center groovemail-opens-clicks-table"
          :url="opensUrl"
          ref="serverTable"
          tableRef="opensTable"
          :tableColumns="opensDataColumns"
          :tableOptions="opensDataOptions"
          @loaded="hideLoader()"
          @loading="showLoader()"
        >
        </server-table>
      </VuePerfectScrollbar>
    </gs-named-modal>

    <gs-named-modal class="gs-refresh-controls"
      id="subscribermodel"
      name="view-clicks-modal"
      :title="$t('frontend_groovemail_broadcasts_unique_clicks')"
    >
      <VuePerfectScrollbar>
        <server-table
          class="w-full text-center groovemail-opens-clicks-table"
          :url="clicksUrl"
          ref="serverTable"
          tableRef="clicksTable"
          :tableColumns="clicksDataColumns"
          :tableOptions="clicksDataOptions"
          @loaded="hideLoader()"
          @loading="showLoader()"
        >
        </server-table>
      </VuePerfectScrollbar>
    </gs-named-modal>

    <gs-named-modal class="gs-refresh-controls"
      id="failedLeadsModal"
      name="failed-leads-modal"
      :title="
        $t('frontend_groovemail_campaigns_failed_leads_tables_header')
      "
    >
      <VuePerfectScrollbar>
        <server-table
          class="w-full text-center groovemail-failed-leads-table"
          ref="serverTable"
          tableRef="failedLeadsTable"
          :url="failedLeadsUrl"
          :tableSlotData="failedLeadsSlotData"
          :tableColumns="failedLeadsDataColumns"
          :tableOptions="failedLeadsDataOptions"
          @loaded="hideLoader()"
          @loading="showLoader()"
        >
        </server-table>
      </VuePerfectScrollbar>
    </gs-named-modal>

    <gs-named-modal class="gs-refresh-controls"
      id="clone-broadcast-modal"
      name="clone-broadcast-modal"
      :title="
        $t('frontend_groovemail_broadcasts_clone_broadcast_modal_title')
      "
    >
      <add-name
        :name="cloneCampaignName"
        nameFieldHeaderText="frontend_groovemail_campaign_name"
        actionButtonText="frontend_groovemail_broadcasts_clone_broadcast_modal_title"
        placeholderText="frontend_name"
        @closeModal="closeCloneBroadcastModal"
        @executeAction="fetchBroadcastData"
      ></add-name>
    </gs-named-modal>


    <!-- confirm modal for broadcast -->
    <confirm-modal
      :ref="`confirmation-campaign-action`"
      :name="`confirmation-campaign-action`"
      :buttonText="$t('frontend_groovemail_frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_swal_revert_message')"
      @confirm="confirmCampaignAction"
      @closed="closeCampaignActionModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import Campaign from '@/models/Campaign';
import themeConfig from '@/theme/themeConfig.js';
import CreateSenderBanner from '@/components/createSenderBanner.vue';
import AddName from '@/components/add-name.vue';

import NavigationTabs from '@/components/navigation-tabs.vue';
import showAlert from '@/components/sweet-alert-popup.js';
import scheduledTimeInEst from '@/components/scheduledTime.js';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

let self;

export default {
  middleware: 'auth',

  metaInfo() {
    return {
      title: this.$t(
        'frontend_groovemail_components_pricepoint_sidebar_broadcasts'
      ),
    };
  },

  mixins: [demoModeValuesMixin],

  components: {
    VuePerfectScrollbar,
    CreateSenderBanner,
    NavigationTabs,
    AddName,
    ServerTable,
  },

  data() {
    return {
      showNavTabs: true,
      percentSwitch: false,
      campaign: [],
      opensTableKey: 1,
      opensUrl: '',
      clicksTableKey: 2,
      clicksUrl: '',
      failedLeadsTableKey: 3,
      failedLeadsUrl: '',
      hideBanner: false,
      showSenderBanner: false,
      campaigns: [],
      last_page: '',
      camp_id: '',
      wizardColor: themeConfig.appPrimaryColor,
      fullPageLoader: true,
      isLoading: false,
      campaignIdToClone: null,
      cloneCampaignName: '',
      emptyStateData: {
        emptyStateHeading: 'frontend_groovemail_broadcasts_route_page_title',
        emptyStateSubHeading: 'frontend_groovemail_broadcasts_have_no_data',
        emptyStateBtnText: 'frontend_groovemail_campains_index_new_campaigns',
      },
      dropdownOptions: [
        {
          text: this.$t('frontend_groovemail_campaign_listing_show_data_as_percentage'),
          showValue: `${this.$t('frontend_groovemail_campaign_listing_show_data_as')} (%)`,
          value: true,
        },
        {
          text: this.$t('frontend_groovemail_campaign_listing_show_data_as_number'),
          showValue: `${this.$t('frontend_groovemail_campaign_listing_show_data_as')} (#)`,
          value: false,
        }
      ],
      navTabs: [
        {
          tabName:
            'frontend_groovemail_components_pricepoint_sidebar_broadcasts',
          tabRoute: 'Broadcasts',
        },
        {
          tabName:
            'frontend_groovemail_components_pricepoint_sidebar_sequences',
          tabRoute: 'Sequences',
        },
        {
          tabName: 'frontend_groovemail_admin_global_templates_page_header',
          tabRoute: 'MyTemplates',
          tabQuery: { type: 'professionally-designed-templates' },
        },
        {
          tabName: 'frontend_groovemail_my_templates_page_header',
          tabRoute: 'MyTemplates',
          tabQuery: { type: 'email-templates' },
        },
      ],
      opensDataColumns: ['first_name', 'last_name', 'email'],
      opensDataOptions: {
        perPage: 5,
        debounce: 1000,
        perPageValues: [5],
        pagination: { chunk: 5 },
        requestFunction(data) {
          const self = this;
          const customUrl = self.url.split('?');
          const campaignId = customUrl[1].split('=')[1];
          return axios
            .post(
              customUrl[0],
              { campaign_id: campaignId },
              {
                params: data,
              }
            )
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data?.data.map((obj) => ({
              ...obj,
              email: self.basicEmailText,
              first_name: self.basicText,
              last_name: self.basicText,
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }

          return {
            data: data.data,
            count: data.total,
          };
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        sortable: [],
        filterable: [],
        headings: {
          first_name: () => this.$t('frontend_resource_promo_first_name'),
          last_name: () => this.$t('frontend_resource_promo_last_name'),
          email: () => this.$t('frontend_resource_promo_email'),
        },
        rowClassCallback(myRowObject) {
          return 'hover:bg-grey-50 funnelRow';
        },
      },
      clicksDataColumns: ['first_name', 'last_name', 'email', 'redirect_url'],
      clicksDataOptions: {
        perPage: 5,
        debounce: 1000,
        perPageValues: [5],
        pagination: { chunk: 5 },
        requestFunction(data) {
          const self = this;
          const customUrl = self.url.split('?');
          const campaignId = customUrl[1].split('=')[1];
          return axios
            .post(
              customUrl[0],
              { campaign_id: campaignId },
              {
                params: data,
              }
            )
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data?.data.map((obj) => ({
              ...obj,
              email: self.basicEmailText,
              first_name: self.basicText,
              last_name: self.basicText,
              redirect_url: self.basicUrlText
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }

          return {
            data: data.data,
            count: data.total,
          };
        },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: [],
        filterable: [],
        headings: {
          first_name: () => this.$t('frontend_resource_promo_first_name'),
          last_name: () => this.$t('frontend_resource_promo_last_name'),
          email: () => this.$t('frontend_resource_promo_email'),
          redirect_url: () => this.$t('frontend_groovemail_contacts_step2_url'),
        },
        rowClassCallback(myRowObject) {
          return 'hover:bg-grey-50 funnelRow';
        },
      },
      failedLeadsDataColumns: ['to_email', 'exception_message'],
      failedLeadsDataOptions: {
        perPage: 5,
        debounce: 1000,
        perPageValues: [5],
        pagination: { chunk: 5 },
        requestFunction(data) {
          const self = this;
          const customUrl = self.url.split('?');
          const campaignId = customUrl[1].split('=')[1];
          return axios
            .post(
              customUrl[0],
              { campaign_id: campaignId },
              {
                params: data,
              }
            )
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data?.data.map((obj) => ({
              ...obj,
              to_email: self.basicEmailText,
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data.data,
            count: data.total,
          };
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        sortable: [],
        filterable: [],
        headings: {
          to_email: () => this.$t('frontend_resource_promo_email'),
          exception_message: () =>
            this.$t(
              'frontend_groovemail_suppressions_enter_emails_unsubscribers_reason'
            ),
        },
        rowClassCallback(myRowObject) {
          return 'hover:bg-grey-50 funnelRow';
        },
      },
      loaderColor: themeConfig.appPrimaryColor,
      mail_listsTableColumns: [
        'name',
        'unique_open_count',
        'unique_click_count',
        'unsubscribe_count',
        'total_recipients',
        'failed_recipients',
        'status',
        'actions',
        'view',
      ],
      mail_listsTableOptions: {
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          noResults: this.$t(
            'frontend_groovemail_broadcasts_no_campaigns_created'
          ),
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: [
          'name',
          'total_recipients',
          'unique_open_count',
          'unique_click_count',
        ],
        headings: {
          name: () => this.$t('frontend_groovemail_campaign_name'),
          unique_open_count: () =>
            this.$t('frontend_groovemail_campains_show_opens'),
          unique_click_count: () =>
            this.$t('frontend_groovemail_campains_show_clicks'),
          unsubscribe_count: () =>
            this.$t('frontend_groovemail_admin_campaign_unsubscibers_short'),
          total_recipients: () =>
            this.$t('frontend_groovemail_campains_show_recipients'),
          failed_recipients: () =>
            this.$t('frontend_groovemail_contacts_step3_failed'),
          status: () => this.$t('frontend_groovemail_campains_show_status'),
          actions: () => this.$t('frontend_groovemail_campains_index_actions'),
        },
        filterByColumn: false,
        filterable: ['name'],
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        requestFunction(data) {
          let paramsData = data;
          if (
            this.$route.query &&
            this.$route.query.sortBy &&
            this.$route.query.type
          ) {
            paramsData = {
              ...data,
              orderBy: 'unique_percent_open_rate',
              ascending: 0,
            };
          } else if (!data.orderBy) {
            paramsData = { ...data, ascending: 0 };
          }
          return axios
            .get(this.url, {
              params: paramsData,
            })
            .catch((e) => {
              this.dispatch('error', e);
              
              // hide loader
              this.hideLoader();
            });
        },
        responseAdapter({ data }) {
          return {
            data: data.data.data ? data.data.data : [],
            count: data.data.total ? data.data.total : 0,
          };
        },
      },

      confirmTargetId: '',
      confirmTarget: '',
    };
  },

  computed: {
    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },

    //  Can mail/Upgraded user/Sandbox mode check
    userCanMail() {
      return this.getCanMail();
    },
    //  Can mail/Upgraded user/Sandbox mode check

    mainTabClass() {
      return 'pb-4 gs-default-tabs-item';
    },

    failedLeadsSlotData() {
      return [
        {
          slotName: 'exception_message',
          slotType: 'tooltip',
          showText: true,
          textValue: (props) => {
            return props.row.exception_message;
          },
          conditions: () => {
            return true;
          },
          content: (props) => {
            return `<div class='mt-2 break-words'><p>${props.row.exception_message}</p></div>`;
          },
          html: () => {
            return `
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="text-danger h-4 w-4" fill="currentcolor">
                <path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"/>
                <path d="M12,10H11a1,1,0,0,0,0,2h1v6a1,1,0,0,0,2,0V12A2,2,0,0,0,12,10Z"/>
                <circle cx="12" cy="6.5" r="1.5"/>
              </svg>
            `;
          },
        },
      ];
    },

    campaignSlotData() {
      return [
        {
          slotName: 'name',
          slotType: 'icon',
          icon: (props) => {
            if (props.row.method === 'email') return 'campaign-email-icon';
            if (props.row.method === 'sms') return 'campaign-sms-icon';

            return 'campaign-postal-icon';
          },
          conditions: () => true,
          classes: 'pointer-events-none',
          description: {
            show: true,
            callback: (props) => {
              if (
                (props.row.emailscheduled === 'savedraft' ||
                  props.row.emailscheduled === 'sendlater') &&
                ![1, -1].includes(props.row.is_processing)
              ) {
                this.editcampaign(props.row.id);
              } else if (
                props.row.is_processing === 1 ||
                props.row.is_completed === 1 ||
                props.row.is_completed === 2 ||
                props.row.is_stop === 1
              ) {
                this.showcampaign(props.row.id);
              }
            },
            html: (props) => {
              if (
                ((props.row.emailscheduled === 'savedraft' ||
                  props.row.emailscheduled === 'sendlater') &&
                  ![1, -1].includes(props.row.is_processing)) ||
                props.row.is_processing === 1 ||
                props.row.is_completed === 1 ||
                props.row.is_completed === 2 ||
                props.row.is_stop === 1
              )
                return `<span class="hover:underline cursor-pointer">${props.row.name}</span>`;
              return `<span>${props.row.name}</span>`;
            },
          },
        },
        {
          slotName: 'unique_open_count',
          slotType: 'default',
          conditions: () => true,
          classes: '',
          callback: (props) => {
            if (props.row.method === 'postal' && props.row.postal_campaign_id)
              this.showStatisticsForPostal(props.row);
            else if ((!this.percentSwitch && props.row.unique_open_count) || (this.percentSwitch && props.row.unique_percent_open_rate)) {
              this.goToShowUniqueOpens(props.row);
            }
          },
          html: (props) => {
            let result;
            if (props.row.method === 'postal' && props.row.postal_campaign_id) {
              result = `<span style="margin-top: -10px;">${this.$t(
                'frontend_groovemail_campaigns_create_postal_integration_postal_click_here_stats'
              )}</span>`;
            } else if (!this.percentSwitch) {
              result = props.row.unique_open_count
                ? `<span class="cursor-pointer font-bold">${props.row.unique_open_count}</span>`
                : `<span>0</span>`;
            } else {
              result = props.row.unique_percent_open_rate
                ? `<span class="cursor-pointer font-bold">${props.row.unique_percent_open_rate}%</span>`
                : `<span>0%</span>`;
            }
            return result;
          },
        },
        {
          slotName: 'unique_click_count',
          slotType: 'default',
          conditions: (props) => {
            return !(
              props.row.method === 'postal' && props.row.postal_campaign_id
            );
          },
          classes: '',
          callback: (props) => {
            if (
              (!this.percentSwitch && props.row.unique_click_count) ||
              (this.percentSwitch && props.row.unique_percent_click_rate)
            )
              this.showUniqueClicks(props.row.id);
          },
          html: (props) => {
            let result;
            if (!this.percentSwitch) {
              result = props.row.unique_click_count
                ? `<span class="cursor-pointer font-bold">${props.row.unique_click_count}</span>`
                : `<span>0</span>`;
            } else {
              result = props.row.unique_percent_click_rate
                ? `<span class="cursor-pointer font-bold">${props.row.unique_percent_click_rate}%</span>`
                : `<span>0%</span>`;
            }
            return result;
          },
        },
        {
          slotName: 'unsubscribe_count',
          slotType: 'computed',
          conditions: (props) => {
            return !(
              props.row.method === 'postal' && props.row.postal_campaign_id
            );
          },
          classes: () => '',
          value: (props) => {
            let result;
            if (!this.percentSwitch) {
              result = props.row.unsubscribe_count || 0;
            } else {
              result = `${props.row.unsubscribe_percent || 0}%`;
            }
            return result;
          },
        },
        {
          slotName: 'total_recipients',
          slotType: 'computed',
          classes: () => '',
          conditions: () => true,
          value: (props) => {
            return props.row.total_recipients ? props.row.total_recipients : 0;
          },
        },
        {
          slotName: 'failed_recipients',
          slotType: 'default',
          conditions: () => true,
          classes: '',
          callback: (props) => {
            if (props.row.method === 'email' && props.row.failed_recipients) {
              this.showFailedEnteries(props.row.id);
            }
          },
          html: (props) => {
            let result;
            if (props.row.method === 'postal') {
              result = `<span>${props.row.failed_recipients || 0}</span>`;
            } else if (props.row.method === 'email') {
              result = props.row.failed_recipients
                ? `<span class="cursor-pointer font-bold">${props.row.failed_recipients}</span>`
                : `<span>0</span>`;
            } else {
              result = `<span>${props.row.failed_recipients || 0}</span>`;
            }
            return result;
          },
        },
        {
          slotName: 'status',
          slotType: 'status',
          classes: (props) => {
            if (props.row.is_completed === 1)
              return 'border-success text-success';
            if (props.row.is_completed === 2)
              return 'border-danger text-danger';
            if (props.row.emailscheduled === 'sendlater')
              return 'border-info text-info';
            if (props.row.is_stop === 1)
              return 'border-danger text-danger';
            if (props.row.emailscheduled === 'sendnow')
              return 'border-purple text-purple';
            if (props.row.emailscheduled === 'savedraft')
              return 'border-warning text-warning';
          },
          statusTitle: (props) => {
            if (props.row.is_completed === 1)
              return this.$t('frontend_groovemail_campains_index_sent');
            if (props.row.is_completed === 2)
              return this.$t('frontend_groovemail_contacts_step3_failed');
            if (props.row.emailscheduled === 'sendlater')
              return this.$t('frontend_groovemail_campains_index_schedule');
            if (props.row.is_stop === 1)
              return this.$t('frontend_groovemail_campains_index_stopped');
            if (props.row.emailscheduled === 'sendnow')
              return this.$t('frontend_groovemail_campains_index_inprocess');
            if (props.row.emailscheduled === 'savedraft')
              return this.$t('frontend_groovemail_campains_index_draft');
          },
          conditions: (props) => {
            if (
              !props.row.is_completed &&
              (props.row.is_stop === 1 ||
                props.row.emailscheduled === 'sendnow' ||
                (props.row.emailscheduled === 'savedraft' &&
                  !props.row.updated_at))
            )
              return false;
            return true;
          },
          value: (props) => {
            if (props.row.is_completed === 1)
              return props.row.broadcastActualSendTime
                ? this.getScheduledTime(props.row.broadcastActualSendTime)
                : this.$t('frontend_affiliate_index_NA');
            if (props.row.is_completed === 2)
              return props.row.broadcastActualSendTime
                ? this.getScheduledTime(props.row.broadcastActualSendTime)
                : this.$t('frontend_affiliate_index_NA');
            if (props.row.emailscheduled === 'sendlater')
              return props.row.actualdate
                ? this.getScheduledTime(props.row.actualdate)
                : this.$t('frontend_affiliate_index_NA');
            if (props.row.emailscheduled === 'savedraft')
              return `
                ${this.$t('frontend_groovemail_campains_index_last_edited')}
                ${parseInt(Math.abs(new Date() - new Date(props.row.updated_at)) / 864e5, 10)}d 
                ${this.$t('frontend_groovemail_campains_index_ago')}
              `;
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_edit'),
              conditions: (row) => {
                return (
                  (row.emailscheduled === 'savedraft' ||
                    row.emailscheduled === 'sendlater') &&
                  ![1, -1].includes(row.is_processing)
                );
              },
              callback: (props) => this.editcampaign(props.row.id),
            },
            {
              id: 1,
              name: () => this.$t('frontend_clone'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.intiateCloneBroadcast(props.row),
            },
            {
              id: 2,
              name: () => this.$t('frontend_groovemail_campains_index_stop'),
              conditions: (row) => {
                return row.is_processing === 1;
              },
              callback: (props) => this.campaignActionModal('stop', props.row.id),
            },
            {
              id: 3,
              name: () => this.$t('frontend_groovemail_campains_index_archive'),
              conditions: (row) => {
                return (
                  row.is_completed === 1 ||
                  row.is_stop === 1 ||
                  row.is_completed === 2
                );
              },
              callback: (props) => this.campaignActionModal('archive', props.row.id),
            },
            {
              id: 4,
              name: () => this.$t('frontend_delete'),
              conditions: (row) => {
                return (
                  row.emailscheduled === 'savedraft' ||
                  row.emailscheduled === 'sendlater' ||
                  (row.is_processed === 0 &&
                    row.is_processing === 0 &&
                    row.is_completed === 0)
                );
              },
              callback: (props) => this.campaignActionModal('delete', props.row.id),
            },
          ],
        },
        {
          slotName: 'view',
          slotType: 'campaign-view',
          firstCondition: (props) => {
            return (
              props.row.is_processing === 1 ||
              props.row.is_completed === 1 ||
              props.row.is_stop === 1
            );
          },
          callback: (props) => this.showcampaign(props.row.id),
          icon: () => {
            return 'snapshot';
          },
          secondCondition: (props) => {
            return (
              props.row.is_completed === 2 &&
              props.row.failed_reason &&
              props.row.static_reason
            );
          },
          content: (props) => {
            return `<div><p class='font-semibold break-words'>${props.row.static_reason}</p></div><div class='mt-2 break-words'><p>(${props.row.failed_reason})</p></div>`;
          },
          html: () => {
            return `
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="text-danger h-4 w-4" fill="currentcolor">
                <path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"/>
                <path d="M12,10H11a1,1,0,0,0,0,2h1v6a1,1,0,0,0,2,0V12A2,2,0,0,0,12,10Z"/>
                <circle cx="12" cy="6.5" r="1.5"/>
              </svg>
            `;
          },
        },
      ];
    },
  },

  async created() {
    self = this;
    

    try {
      await this.fetchSenderStatus();

      if (this.$route.query && this.$route.query.sortBy && this.$route.query.type && this.$route.query.type === 'percent') {
        this.percentSwitch = true;
      }
    } catch (error) {
      // show error alert
      this.requestErrorAlert(error.response?.data?.error);
    }
  },

  methods: {
    //  Can mail/Upgraded user/Sandbox mode check
    ...mapGetters('mailing', ['getCanMail']),
    //  Can mail/Upgraded user/Sandbox mode check

    async showFailedEnteries(campaignId) {
      this.failedLeadsUrl = `/campaign/failed-recipient-list?campaignId=${campaignId}`;
      this.$root.$emit('modal-open', 'failed-leads-modal');
    },


    /**
     * Redirects to Contacts page that displays all contacts that open the email.
      * @param {Object} campaign
    */
    goToShowUniqueOpens(campaign) {
      this.$router.push({
        name: 'Leads2',
        query: { broadcastsOpenId: campaign.id, broadcastsOpenName: campaign.name},
      });
    },

    getScheduledTime(actualDate) {
      return scheduledTimeInEst(actualDate);
    },

    async showUniqueClicks(campaignId) {
      this.clicksUrl = `/who/clicked?campaignId=${campaignId}`;
      this.$root.$emit('modal-open', 'view-clicks-modal');
    },

    async editcampaign(campaignid) {
      this.showNavTabs = false;
      this.$router.push({ name: 'EditCampaign', params: { id: campaignid } });
    },

    closeSenderBanner() {
      this.hideBanner = true;
    },

    openCreateCampaign() {
      this.showNavTabs = false;
      this.$router.push({ name: 'NewCampaign' });
    },

    fetchCamapigns(pageNum) {
      this.showLoader();

      axios.get('/campaign', { params: { page: pageNum } })
        .then((response) => {
          const result = response.data.data;
          this.campaigns = result.data;
          this.last_page = result.last_page;
          this.hideLoader();
        })
        .catch((error) => {
          // show error alert
          this.requestErrorAlert(error.response?.data?.error);
        });
    },

    async fetchSenderStatus() {
      // show loader
      this.showLoader();

      try {
        const sendersData = await axios.get('/email-sms-sender');
        if (sendersData.data.admin_setting && !sendersData.data.account_senders) {
          this.showSenderBanner = true;
        } else {
          this.showSenderBanner = false;
        }
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);
      }
    },


    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      // show error alert
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },


    // open campaign confirm action modal
    async campaignActionModal(option, id) {
      // set the confirm target id
      this.confirmTargetId = id;

      // set the target option
      this.confirmTarget = option;
      
      // open the modal
      this.$refs[`confirmation-campaign-action`].open();
    },

    // close campaign confirm action modal
    closeCampaignActionModal() {
      // close the modal
      this.$refs[`confirmation-campaign-action`].close();

      // reset the confirm target
      this.confirmTarget = '';
      this.confirmTargetId = '';
    },


    // confirm the campaign action
    confirmCampaignAction () {
      if(this.confirmTarget === 'archive') {
        this.archivecampaign();
      } else if(this.confirmTarget === 'stop') {
        this.stopcampaign();
      } else if(this.confirmTarget === 'delete') {
        this.deletecampaign();
      }
    },

    // archive campaign
    async archivecampaign() {
      this.showLoader();
      // get campaign
      const targetCampaign = await Campaign.$find(this.confirmTargetId);

      try {
        // stop campaign method
        await targetCampaign.campaignArchive(this.confirmTargetId);

        // refetch campaign listing data
        await this.refetchBroadcastsListing();
      } catch (error) {
        // show error alert
        await this.requestErrorAlert(error.response?.data?.error);
      }
    },

    // stop campaign
    async stopcampaign() {
      this.showLoader();
      // get campaign
      const targetCampaign = await Campaign.$find(this.confirmTargetId);

      try {
        // stop campaign method
        await targetCampaign.campaignStop(this.confirmTargetId);

        // refetch broadcasts
        await this.refetchBroadcastsListing();
      } catch (error) {
        // show error alert
        await this.requestErrorAlert(error.response?.data?.error);
      }
    },

    // delete campaign
    async deletecampaign() {
      this.showLoader();

      try {
        // get campaign
        const targetCampaign = await Campaign.$find(this.confirmTargetId);
       
        // delete campaign method
        await targetCampaign.campaignDelete(this.confirmTargetId);
        
        // refetch campaign listing data
        await this.refetchBroadcastsListing();
      } catch (error) {
        // show error alert
        await this.requestErrorAlert(error.response?.data?.error);
      }
    },

    // show loader
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    // hide loader
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    showcampaign(Id) {
      this.showNavTabs = false;
      this.$router.push({
        name: 'CampaignDetail',
        params: { id: Id },
        query: { from: 'broadcast-listing' },
      });
    },

    sortedTable() {
      this.refetchBroadcastsListing(1);
    },

    refetchBroadcastsListing(pageNo) {
      this.$refs.serverTable.$refs.campaignsTable.setPage(
        pageNo || this.$refs.serverTable.$refs.campaignsTable.Page
      );
    },

    showStatisticsForPostal(postalData) {
      window.open(
        `https://app.closem.ai/index.php?m=campaigns&d=campaigndetails&id=${postalData.postal_campaign_id}`
      );
    },

    openCloneBroadcastModal() {
      this.$root.$emit('modal-open', 'clone-broadcast-modal');
    },

    closeCloneBroadcastModal() {
      this.$root.$emit('modal-close', 'clone-broadcast-modal');
    },

    intiateCloneBroadcast(broadcast) {
      this.campaignIdToClone = broadcast.id;
      this.cloneCampaignName = `${broadcast.name} [ ${this.$t(
        'frontend_copy'
      ).toUpperCase()} ]`;
      this.openCloneBroadcastModal();
    },

    async fetchBroadcastData(newBroadcastName) {
      try {
        this.showLoader();

        // get the clone campaign data
        const campaignToClone = await Campaign.$find(this.campaignIdToClone);

        // check if campaign has email_id or template_id
        let newEmailId = null;
        if (campaignToClone.email_id || campaignToClone.template_id) {
          // if it have clone the target campaign template and get the new template id
          newEmailId = await axios.put(`/email/template/clone/${campaignToClone.email_id || campaignToClone.template_id}`);
        }

        // prepare broadcast data for clone request
        await this.prepareBroadcastData(
          campaignToClone,
          newBroadcastName,
          newEmailId?.data?.id
        );
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    // prepare broadcast data for clone request
    async prepareBroadcastData(campaignToClone, name, emailId = null) {
      const campaignData = new Campaign({});
      campaignData.name = name;

      if (campaignToClone.campaign_tags && campaignToClone.campaign_tags.length) {
        campaignData.campaign_tags = campaignToClone.campaign_tags;
      }

      campaignData.method = campaignToClone.method;
      campaignData.gateway = campaignToClone.gateway;
      campaignData.sender_id = campaignToClone.sender_id ? campaignToClone.sender_id : null;
      campaignData.sendername = campaignToClone.sendername;
      campaignData.senderemail = campaignToClone.senderemail;
      
      // check if conditions is string or object
      if (typeof campaignToClone.conditions === 'string') {
        campaignData.conditions = JSON.parse(campaignToClone.conditions);
      } else {
        campaignData.conditions = campaignToClone.conditions;
      }

      if (campaignToClone.method === 'postal' && campaignToClone.postal_sequence_id) {
        campaignData.postal_sequence_id = campaignToClone.postal_sequence_id;
      }

      campaignData.emailtype = campaignToClone.emailtype;
      if (campaignToClone.subject) {
        campaignData.subject = campaignToClone.subject;
      }
      if (campaignToClone.previewtext) {
        campaignData.previewtext = campaignToClone.previewtext;
      }


      campaignData.editor_type = campaignToClone.editor_type ? campaignToClone.editor_type : 1;

      campaignData.message = emailId || campaignToClone.message;

      if (campaignData.method === 'email') {
        if (campaignToClone.emailContentSections) {
          campaignData.emailContentSections = campaignToClone.emailContentSections;
        }
        if (emailId) {
          campaignData.email_id = emailId;
          campaignData.template_id = emailId;
        }
      }

      campaignData.sheduledtime = campaignToClone.sheduledtime;
      campaignData.emailscheduled = 'savedraft';

      // call clone broadcast function
      await this.cloneBroadcast(campaignData);
    },

    // clone broadcast function
    async cloneBroadcast(campaignData) {
      try {
        this.showLoader();

        // clone campaign request
        await campaignData.cloneCampaign(campaignData);
        
        // close clone broadcast modal
        this.closeCloneBroadcastModal();
        
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);
      }
      
      // refetch broadcasts
      await this.refetchBroadcastsListing();
    },

    changeDataView(value) {
      this.percentSwitch = value;
    },
  },
};
</script>

<style lang="scss">
.groovemail-campaigns-table {
  .VueTables--server .table-responsive {
    th:nth-child(1),
    td:nth-child(1) {
      width: 17%;
      padding-left: 20px !important;
    }
    th:nth-child(2),
    td:nth-child(2),
    th:nth-child(3),
    td:nth-child(3),
    th:nth-child(4),
    td:nth-child(4) {
      width: 9%;
    }
    th:nth-child(5),
    td:nth-child(5) {
      width: 10%;
    }
    th:nth-child(6),
    td:nth-child(6) {
      width: 8%;
    }
    th:nth-child(7),
    td:nth-child(7) {
      width: 23%;
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
    th:nth-child(8),
    td:nth-child(8) {
      width: 10%;
      padding-left: 5px !important;
      padding-right: 5px !important;
    }

    // responsive table styles
    @media  only screen and (max-width: 1024px) {
      th:nth-child(1),
      td:nth-child(1),
      th:nth-child(7),
      td:nth-child(7) {
        min-width: 200px;
      }
      th:nth-child(2),
      td:nth-child(2),
      th:nth-child(3),
      td:nth-child(3),
      th:nth-child(4),
      td:nth-child(4) {
        min-width: 100px;
      }
      th:nth-child(5),
      td:nth-child(5),
      th:nth-child(8),
      td:nth-child(8) {
        min-width: 110px;
      }
    }
  }

  .VueTables__table th:nth-child(8) span {
    display: none;
  }

  .camp-stat-switch {
    margin: 0px 5px !important;
  }
}

.gs-default-tabs-item:focus {
  outline: none !important;
  outline-style: none !important;
}

.groovemail-failed-leads-table,
.groovemail-opens-clicks-table {
  .VueTables--server {
    .table-responsive {
      background: #ffffff !important;
      .VueTables__table {
        th:last-child span {
          display: block !important;
        }
        border: 1px solid #ccc !important;
      }
    }
    td {
      word-break: break-all;
    }
    .VuePagination {
      margin-bottom: 10px;
    }

    padding: 1.5rem;
  }
}

.groovemail-failed-leads-table {
  .VueTables--server {
    .table-responsive {
      .VueTables__table {
        th:nth-child(1),
        td:nth-child(1) {
          width: 40%;
        }
        th:nth-child(2),
        td:nth-child(2) {
          width: 60%;
        }
      }
    }
  }
}

.gm-nav-campaigns-tabs {
  top: 37px;
  z-index: 10;
}

.gm-nav-campaigns-tabs-no-sender {
  top: 93px;
  z-index: 10;
}
</style>

<style scoped>
.gm-campaigns-refresh {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gm-campaigns-refresh__workspace {
  min-width: 0;
  padding: 20px 24px 24px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gm-campaigns-refresh >>> .VueTables__table,
.gm-campaigns-refresh >>> .VueTables__table th,
.gm-campaigns-refresh >>> .VueTables__table td {
  border-color: var(--gs-border);
}

@media (max-width: 640px) {
  .gm-campaigns-refresh { padding: 18px 12px 32px; }
  .gm-campaigns-refresh__workspace { padding: 16px; }
}
</style>
